export default {"src":"/_next/static/media/mobileIcon.9607bf73.svg","height":25,"width":17};